interface FormError {
  /** Error message to be displayed */
  message: string;

  /** Name of error, must match name of field the error is being applied to, or in case of form level errors, the `formErrorName` prop of the form */
  name: string;
}

/**
 * Class for applying form and field level errors to form onSubmit
 */
export class FormValidationError extends Error {
  errors: FormError[];

  /**
   * Owner details
   * @param formName Name prop of form where errors are being applied
   * @param errors Array of `FormError` objects, documented above
   */
  constructor(formName: string, errors: FormError[]) {
    super(`There has been error validating form ${formName}`);

    /**
     * Name of the error
     */
    this.name = 'FormValidationError';

    /**
     * Array of `FormError` objects, documented above
     */
    this.errors = errors;
  }
}
